import { createAction, handleActions } from "redux-actions";

import {
  api,
} from "../../services";

import {
  creditInterface,
  CreditPackageInterface,
  rootReducerInterface,
} from "../../typings/interfaces";

const CREDITS_GET = "CREDITS_GET";

// ACTIONS

// Get module promotions
export const getCredits = createAction(
  CREDITS_GET,
  async (
    callback?: (creditPackages: CreditPackageInterface[] | Boolean) => void
  ) => {
    try {
      const creditPackages = await api.Credit.list();

      if (creditPackages.length == 0) {
        callback && callback(false);
        return [];
      }

      callback && callback(creditPackages);
      return creditPackages;
    } catch (error) {
      callback && callback(false);
      return [];
    }
  }
);

// SELECTORS
export const selectCredits = (state: rootReducerInterface) =>
  state.credit.packages;

// INITIAL STATE
const initialState: creditInterface = {
  packages: [],
};


// REDUCERS
const creditReducers = {
  setCreditPackages: (state: creditInterface, { payload }) => ({
    ...state,
    packages: !payload ? [] : [...payload]
  }),
};

export default handleActions(
  {
    [CREDITS_GET]: creditReducers.setCreditPackages,
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/routes/Credit/credit.ducks.ts